<template>
    <div class="px-38 refer">
        <span class="inSpan" v-for="(item,index) in refer" :key="index">{{item}}</span>
    </div>
</template>

<script>
export default {
    data(){
        return{
            refer:['参考资料：《医学影像设备学》   主编：石明国 韩丰谈   出版社：人民卫生出版社   标准书号：ISBN  978-7-117-22875-6/R·22876',
            '参考资料：《医学影像设备学》   主编：黄祥国 李燕   出版社：人民卫生出版社   标准书号：ISBN  978-7-117-19035-0',
            '参考资料：《医学影像设备学实验教程》   主编 石明国 韩丰谈   出版社：人民卫生出版社   标准书号：ISBN  978-7-117-23244-9/R·23245',
            '参考资料：《医学影像设备原理与维护》   主编 郝利国   出版社：浙江大学出版社   标准书号：ISBN  978-7-308-16501-3',
            '参考资料：《医学影像设备》   主编：冯开梅 卢振明   出版社：人民卫生出版社   标准书号：ISBN-978-7-117-21643-2 等']
        }
    }
}
</script>